export const useErrorMessage = () => {
  const nuxtApp = useNuxtApp();
  return nuxtApp.$errorMessage;
};
